import { render, staticRenderFns } from "./CreateCourseFolder.vue?vue&type=template&id=00d385a4"
import script from "./CreateCourseFolder.vue?vue&type=script&lang=js"
export * from "./CreateCourseFolder.vue?vue&type=script&lang=js"
import style0 from "./CreateCourseFolder.vue?vue&type=style&index=0&id=00d385a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports